import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import history from "../history";
import Swal from "sweetalert2";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

import { env } from "configs/EnvironmentConfig";

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000, // 1 minutos
});
// Config
const ENTRY_ROUTE = "/#/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const PUBLIC_REQUEST_KEY = "public-request";
const AUTH_TOKEN = "authUser";

// API Request interceptor
service.interceptors.request.use(
	(config) => {
		const localAuthToken = JSON.parse(localStorage.getItem(AUTH_TOKEN));
		const jwtToken =
			localAuthToken && localAuthToken.token
				? `${localAuthToken.token_type} ${localAuthToken.token}`
				: null;

		if (jwtToken) {
			config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
			
			// Sempre tenta enviar company_id se existir e for válido
			const companyId = localStorage.getItem("company_id");
			if (companyId && companyId !== "null") {
				config.headers["company_id"] = companyId;
			}
			// Se company_id não existir ou for null, algumas rotas específicas
			// ainda funcionarão (company, permissions) e retornarão []
		}

		if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
			if (localStorage.getItem("company_id")) {
				localStorage.removeItem("company_id");
			}
			history.push(`${env.PUBLIC_PREFIX_PATH}/#/login`);
			window.location.reload();
		}

		return config;
	},
	(error) => {
		// Do something with request error here
		notification.error({
			message: "Error",
		});
		Promise.reject(error);
	},
);

// API respone interceptor
service.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		let notificationParam = {
			message: "",
		};

		if (!error.response) {
			notificationParam.message = "Erro inesperado";
			// colocar notificação do skote
			return Promise.reject(error);
		}

		// Remove token and redirect
		if (error.response.status === 400) {
			notificationParam.message =
				error?.response?.data?.message ?? "Erro inesperado";
		}

		if (
			error.response.status === 401 &&
			!error?.response?.data?.new_password_required &&
			!error?.response?.data?.isLogin
		) {
			notificationParam.message = "Falha na autenticação";
			notificationParam.description =
				error.response?.data?.message ?? "Erro inesperado";
			localStorage.removeItem(AUTH_TOKEN);
			localStorage.removeItem("company_id");
			notificationParam.message = "Sua sessão expirou";

			history.push(`${env.PUBLIC_PREFIX_PATH}${ENTRY_ROUTE}`);
			window.location.reload();

			return Promise.reject(error);
		}

		if (error.response.status === 404 || error.response.status === 500) {
			if (error.response.data?.message) {
				notificationParam.message = error.response.data.message;
			} else if (error.response.data?.error) {
				notificationParam.message = error.response.data.error;
			} else {
				notificationParam.message = "Not Found";
			}
		}

		if (error.response?.status === 403) {
			// Não redireciona para 403 se for um erro de password_change_required no login
			if (!error?.response?.data?.password_change_required) {
				history.push("/#/403");
				window.location.reload();
			}
			// return Promise.reject(error);
		}

		if (error.response.status === 508) {
			notificationParam.message = "Time Out";
		}

		// 409 INACTIVE_USER_EXISTS é tratado no formulário de usuário com modal próprio
		if (
			error.response?.status === 409 &&
			error.response?.data?.code === "INACTIVE_USER_EXISTS"
		) {
			return Promise.reject(error);
		}

		const message = !notificationParam.message
			? error?.response?.data?.message
			: notificationParam.message;
		SendaCustomSwal.fire({
			iconHtml: '<i class="error-icon"></i>',
			title: "Oops...",
			text: message,
			customClass: {
				confirmButton: "custom-confirm-button",
			},
		});

		return Promise.reject(error);
	},
);

export default service;
